module.exports = __webpack_public_path__ + "static/img/technology-2.eb3c95d1.png";